"use client";
import NextLink, { type LinkProps } from "next/link";
import { useTransition } from "react";

export default function Link(
  props: LinkProps & React.HTMLProps<HTMLAnchorElement>,
) {
  const [, startTransition] = useTransition();

  return (
    <NextLink
      {...props}
      onNavigate={(e: { preventDefault: () => void }) => {
        if (!navigator.onLine) {
          e.preventDefault();
          startTransition(() => {
            throw new Error("__OFFLINE__");
          });
        }
      }}
    >
      {props.children}
    </NextLink>
  );
}
